<template>
  <v-app :style="{ backgroundColor: '#F5F7FA' }">
    <Header></Header>
    <div v-if="isInitializing" class="app-loading-screen">
      <p>Loading application...</p>
    </div>
    <v-main v-else>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Headers/Header.vue"
export default {
  name: "App",
  components:{Header},
  computed:{
    getUserCompany(){
      return this.$store.getters.getUserCompany
    },
    getAuthenticated(){
      return this.$store.getters.getAuthenticated
    }
  },
  data: () => ({
    isInitializing: true
  }),
  async mounted(){
    const slug = this.getSlug()
    if(slug && !this.getAuthenticated){
      try {
        await this.$store.dispatch('setCompanyContext', {company:null, fresh:true, slug:slug});
      } catch (error) {
        console.error('Failed to initialize company context:', error);
      } finally {
        this.isInitializing = false;
      }
    }else if(this.getUserCompany && this.getUserCompany.emis){
      try {
        await this.$store.dispatch('setCompanyContext', {company:null, fresh:false, slug:null});
      } catch (error) {
        console.error('Failed to initialize company context:', error);
      } finally {
        this.isInitializing = false;
      }
    }else{
      try {
        await this.$store.dispatch('setCompanyContext', {company:null, fresh:true, slug:null});
      } catch (error) {
        console.error('Failed to initialize company context:', error);
      } finally {
        this.isInitializing = false;
      }
    }
  },
  methods:{
    getSlug(){
      const url = window.location.pathname
      if(!url.includes("/dashboard/")){
        return null;
      }
      const slug = url.split('/dashboard/')[1]
      return slug;
    }
  }
  

};
</script>
